// Container.js
const Container = ({ children }) => (
    <div className="max-w-4xl mx-auto p-4 bg-wedding-bg-light shadow-lg">
        {children}
    </div>
);

export default Container;
